import { render, staticRenderFns } from "./BasicHeader.vue?vue&type=template&id=1d6411ee&scoped=true&lang=pug&"
import script from "./BasicHeader.vue?vue&type=script&lang=js&"
export * from "./BasicHeader.vue?vue&type=script&lang=js&"
import style0 from "./BasicHeader.vue?vue&type=style&index=0&id=1d6411ee&lagn=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6411ee",
  null
  
)

export default component.exports